import React from 'react';
import { List, Card, Typography } from 'antd';
import { useHistory } from 'react-router-dom';
import '../../assets/css/SelectModulPage.css'; // Ensure CSS file is imported

const { Title, Text } = Typography;

const SelectModulPage = () => {
  const history = useHistory();

  const handleClose = () => {
    history.push("/");
  };

  const modules = [
    {
      title: (
        <div>
          <Title level={4} className="card-title">
            ААНОАТ - АЖ АХУЙН НЭГЖИЙН ОРЛОГЫН АЛБАН ТАТВАРЫН ТАЙЛАН
          </Title>
          <Text className="card-text">
            Аж ахуй нэгжийн орлогын албан татварын тооцоолол, тайлан /ААНОАТ
            тайлан, СБТТҮХЗөрүүг зохицуулах тайлан/
          </Text>
        </div>
      ),
      onClick: () => {
        localStorage.setItem('modul', 'main');
        handleClose();
      },
    },
    {
      title: (
        <div>
          <Title level={4} className="card-title">
            НӨАТ - НЭМЭГДСЭН ӨРТГИЙН АЛБАН ТАТВАРЫН ТАЙЛАН
          </Title>
          <Text className="card-text">
            Борлуулсан болон худалдан авсан бараа ажил үйлчилгээний ибаримт
            тулгалт хяналт, НӨАТ тооцоолол, тайлан /НӨАТ суутган төлөгчийн
            тайлан/
          </Text>
        </div>
      ),
      onClick: () => {
        localStorage.setItem('modul', 'noat');
        handleClose();
      },
    },
    {
      title: (
        <div>
          <Title level={4} className="card-title">
            ХХОАТ - ХУВЬ ХҮНИЙ ОРЛОГОД АЛБАН ТАТВАРЫН ТАЙЛАН
          </Title>
          <Text className="card-text">
            Цалин, хөдөлмөрийн хөлс, шагнал, урамшуулал болон тэдгээртэй
            адилтгах хөдөлмөр эрхлэлтийн орлого, шууд бус орлогод ногдуулан
            суутгасан албан татварын тайлан
          </Text>
        </div>
      ),
      onClick: () => {
        localStorage.setItem('modul', 'hhoat');
        handleClose();
      },
    },
  ];

  return (
    <div className="role-add-container">
      <div className="modal-header">
        <Typography.Title level={3} className="page-title">
          Модуль сонгох
        </Typography.Title>
      </div>
      <List
        className="list-container"
        dataSource={modules}
        renderItem={(item) => (
          <List.Item className="list-item">
            <Card
              className="card-container"
              onClick={item.onClick}
              bordered={false}
              hoverable
            >
              {item.title}
            </Card>
          </List.Item>
        )}
      />
    </div>
  );
};

export default SelectModulPage;